import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

const BASE = "https://www.serconsulting.org";

export const Seo = ({ page, title, description, noindex = false }) => {
  const { lang, t } = useLang();
  const location = useLocation();

  useEffect(() => {
    const meta = t.seo[page] || t.seo.home;
    const finalTitle = title || meta.title;
    const finalDesc = description || meta.desc;
    const rest = location.pathname.replace(/^\/(es|en)/, "") || "";
    const url = `${BASE}/${lang}${rest}`;

    document.title = finalTitle;
    document.documentElement.lang = lang;

    const setMeta = (attr, key, value) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };
    const setLink = (selector, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("link");
        document.head.appendChild(el);
      }
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    };

    setMeta("name", "description", finalDesc);
    setMeta("name", "robots", noindex ? "noindex,follow" : "index,follow");
    setMeta("property", "og:title", finalTitle);
    setMeta("property", "og:description", finalDesc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", `${BASE}/assets/logo-mark.png`);
    setMeta("property", "og:locale", lang === "es" ? "es_ES" : "en_US");
    setMeta("name", "twitter:card", "summary");
    setMeta("name", "twitter:title", finalTitle);
    setMeta("name", "twitter:description", finalDesc);
    setMeta("name", "twitter:image", `${BASE}/assets/logo-mark.png`);

    setLink('link[rel="canonical"]', { rel: "canonical", href: url });
    setLink('link[hreflang="es"]', { rel: "alternate", hreflang: "es", href: `${BASE}/es${rest}` });
    setLink('link[hreflang="en"]', { rel: "alternate", hreflang: "en", href: `${BASE}/en${rest}` });
    setLink('link[hreflang="x-default"]', { rel: "alternate", hreflang: "x-default", href: `${BASE}/es${rest}` });
  }, [page, lang, t, location.pathname, title, description, noindex]);
  return null;
};
